import React from "react";
import Page from "./TodaysViewCheckInOutPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";
import TodaysViewCheckInOutPage from "./TodaysViewCheckInOutPage";

interface TodaysViewCheckInOutPageContainerProps extends RouteProps, withValidUserRoleProps {}

const TodaysViewCheckInOutPageContainer = (props: TodaysViewCheckInOutPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <TodaysViewCheckInOutPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(TodaysViewCheckInOutPageContainer);
